import { createFeatureSelector, createSelector } from '@ngrx/store';
import { attributeFeatureKey, AttributeState } from './attribute-reducer';

export const getFilterAttributeState =
  createFeatureSelector<AttributeState>(attributeFeatureKey);

export const getAttributeState = createSelector(
  getFilterAttributeState,
  (state: AttributeState) => state
);
